'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('textAlign', 'align');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/text-align.js
// module id = 243
// module chunks = 35783957827783 64089156084587 91322373450782 114276838955818